import { createSlice } from '@reduxjs/toolkit';
import { pageModel } from '../../utils/model';

const initialState = {
    searchParams: {
        id: "",
        code: "",
        name: "",
    },
    page: pageModel
}

const supplierSlice = createSlice({
    name: 'supplier',
    initialState,
    reducers: {
        setSupplierPageAction: (state, action) => {
            state.page = action.payload
        },
        getSupplierPageAction: (state, action) => {
            const content = state.page.content.concat(action.payload.content)
            state.page = { ...action.payload, content }
        },
        addSupplierAction: (state, action) => {
            state.page.content.unshift(action.payload)
        },
        updateSupplierAction: (state, action) => {
            const content = state.page.content.map((x) => {
                if (x.id === action.payload.id) return action.payload
                else return x
            })
            state.page.content = content
        },
        deleteSupplierAction: (state, action) => {
            const content = state.page.content.filter(x => x.id !== action.payload)
            state.page.content = content
        },
        uploadSupplierExcelFileAction: (state, action) => {
            let content = [...action.payload.reverse(), ...state.page.content]
            state.page.content = content
            // state.page.content = content
        },
        setSupplierSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.searchParams = { ...state.searchParams, [key]: value }
        }
    },
});

export const { setSupplierSearchParamsAction, setSupplierPageAction, getSupplierPageAction, addSupplierAction, updateSupplierAction, deleteSupplierAction, uploadSupplierExcelFileAction } = supplierSlice.actions;
export default supplierSlice;